import React, { useState, useEffect } from 'react'
import { Grid, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Form from '../../../components/FormControls/Form'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { isEmail } from 'validator'
import { CircularProgress } from '@material-ui/core'
import { useForm } from '../../../providers/FormProvider'
import { createBooking } from '../../../services'
import { useAuth } from '../../../providers'
import DoneIcon from '@material-ui/icons/Done'
import { toastConfig, reactGAEvent } from '../../../utils'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { CustomerName } from './CustomerName'
import { CompanyName } from './CompanyName'
import { CustomerPhoneNumber } from './CustomerPhoneNumber'
import { CustomerEmail } from './CustomerEmail'

const useStyles = makeStyles((theme) => {
    return {
        container: {
            border: 'solid 1px red',
        },
        selectMultiple: {
            margin: '1rem 0rem',
        },
        label: {
            marginBottom: '0.5rem',
        },
        numOfRequirementContainer: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        btn: {
            width: '50%',
            textTransform: 'none',
            fontSize: '1rem',
            marginBottom: theme.spacing(4),
            marginTop: theme.spacing(4),
            padding: '0.5rem 1.5rem',
        },
        center: {
            display: 'flex',
            justifyContent: 'center',
        },
        padding: {
            paddingTop: '2rem',
            paddingLeft: 'none',
        },
        fullWidth: {
            width: '100%',
        },
        flex: {
            display: 'flex',
            gap: theme.spacing(4),
        },
    }
})

const createBookingInitialState = {
    status: 'idle',
    error: null,
}

const submitButtonIcons = {
    idle: <ArrowRightAltIcon />,
    success: <DoneIcon />,
    failed: <ArrowRightAltIcon />,
    loading: '',
}

export const BookingFormPartTwo = () => {
    const classes = useStyles()
    const { formState, dispatch, setError, handleBack } = useForm()
    const [bookingState, setBookingState] = useState(createBookingInitialState)
    const { status } = bookingState
    const { userId } = useAuth()
    const navigate = useNavigate()

    const onSubmit = async () => {
        reactGAEvent('Button', 'Booking form submit button clicked')
        const errorObj = {}
        setError((prevError) => ({ ...prevError, error: {} }))

        if (!isEmail(formState.email)) {
            errorObj['email'] = { error: 'Please enter a valid email' }
        }

        if (formState.phoneNumber.length !== 10) {
            errorObj['phoneNumber'] = {
                error: 'Phone number must be 10 digit long',
            }
        }

        const requiredFields = ['name', 'email', 'phoneNumber', 'cmpName']

        requiredFields.forEach((field) => {
            if (formState[field].length === 0) {
                errorObj[field] = { error: 'Please fill this field' }
            }
        })

        setError({ ...errorObj })
        if (Object.keys(errorObj).length === 0) {
            try {
                setBookingState((prevState) => ({ ...prevState, status: 'loading' }))
                const res = await createBooking(formState, userId)
                console.log(res)
                if (res?.data?.success) {
                    return setBookingState((prevState) => ({
                        ...prevState,
                        status: 'success',
                    }))
                }

                toast.error(res?.data?.error, toastConfig)
                setBookingState((prevState) => ({
                    ...prevState,
                    status: 'failed',
                    error: res?.data?.error,
                }))
            } catch (error) {
                console.log(error)
            }
        }
    }

    useEffect(() => {
        if (status === 'success') {
            //set status back to idle
            dispatch({ type: 'RESET' })
            handleBack()
            navigate('/booking-success')
        }
    }, [status, dispatch, handleBack, navigate])

    return (
        <Form>
            <Grid container>
                <Grid item xs={12}>
                    <CompanyName />
                    <CustomerName />
                    <CustomerPhoneNumber />
                    <CustomerEmail />
                    <div className={classes.flex}>
                        <Button
                            className={classes.btn}
                            onClick={handleBack}
                            size="large"
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            startIcon={<ArrowBackIcon />}
                        >
                            Back
                        </Button>

                        <Button
                            className={classes.btn}
                            onClick={onSubmit}
                            size="large"
                            variant="contained"
                            disabled={status === 'loading'}
                            color="primary"
                            fullWidth
                            endIcon={submitButtonIcons[status]}
                        >
                            {status === 'loading' ? <CircularProgress size={30} /> : `Submit`}
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </Form>
    )
}
